import { matchPath } from 'react-router-dom';
import { getMarketByCode } from '../config';
export default function detectMarket(pathname) {
    var _a;
    const match = matchPath(pathname, {
        path: `/:market`,
    });
    const market = (_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.market;
    if (!market) {
        return undefined;
    }
    const marketCode = getMarketByCode(market);
    if (!marketCode) {
        return undefined;
    }
    return marketCode;
}
